interface Order {
  order: string;
}

export const sort = <T, K = Order & T>(orders: K[]): K[] => {
  return orders.sort((a: any, b: any) => Number(a.order) - Number(b.order));
};
